/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './icon-button.component';
import * as import2 from '@angular/common';
import * as import3 from '../../html-utils/css-var.directive';
import * as import4 from '../../ui-elements/touchable.directive';
import * as import5 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import6 from '../../ui-elements/icon/icon.component';
const styles_IconButtonComponent:any[] = ([] as any[]);
export const RenderType_IconButtonComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_IconButtonComponent,
  data: {}
}
);
export function View_IconButtonComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'icon-button'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import1.IconButtonComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.activate($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import2.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'circular',
      'enlarged'
    ]
    ),
      import0.ɵdid(671744,(null as any),0,import3.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod(['--default-icon-size']),
    import0.ɵdid(4210688,(null as any),0,import4.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'icon-button-icon'
      ]
    ],(null as any),(null as any),(null as any),import5.View_IconComponent_0,import5.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import6.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import1.IconButtonComponent = v.component;
    const currVal_0:any = 'icon-button';
    const currVal_1:any = ck(v,2,0,co.circular,co.enlarged);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,4,0,(co.defaultIconSize + 'px'));
    ck(v,3,0,currVal_2);
    const currVal_3:any = co.iconName;
    ck(v,8,0,currVal_3);
  },(null as any));
}
function View_IconButtonComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),View_IconButtonComponent_0,RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import1.IconButtonComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const IconButtonComponentNgFactory:import0.ComponentFactory<import1.IconButtonComponent> = import0.ɵccf('woa-icon-button',import1.IconButtonComponent,View_IconButtonComponent_Host_0,{
  type: 'type',
  icon: 'icon',
  disabled: 'disabled',
  unavailable: 'unavailable',
  circular: 'circular',
  enlarged: 'enlarged'
}
,{onActivate: 'onActivate'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvYnV0dG9ucy9pY29uLWJ1dHRvbi9pY29uLWJ1dHRvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9idXR0b25zL2ljb24tYnV0dG9uL2ljb24tYnV0dG9uLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvYnV0dG9ucy9pY29uLWJ1dHRvbi9pY29uLWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvYnV0dG9ucy9pY29uLWJ1dHRvbi9pY29uLWJ1dHRvbi5jb21wb25lbnQudHMuSWNvbkJ1dHRvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJpY29uLWJ1dHRvblwiIHdvYS10b3VjaGFibGVcbiAgICAgW25nQ2xhc3NdPVwie1xuICAgICAgICAnY2lyY3VsYXInOiBjaXJjdWxhcixcbiAgICAgICAgJ2VubGFyZ2VkJzogZW5sYXJnZWRcbiAgICAgfVwiXG4gICAgIFt3b2EtY3NzLXZhcl09XCJ7Jy0tZGVmYXVsdC1pY29uLXNpemUnOiBkZWZhdWx0SWNvblNpemUgKyAncHgnfVwiXG4gICAgIChjbGljayk9XCJhY3RpdmF0ZSgkZXZlbnQpXCI+XG4gICAgPHdvYS1pY29uIGNsYXNzPVwiaWNvbi1idXR0b24taWNvblwiIFtuYW1lXT1cImljb25OYW1lXCI+PC93b2EtaWNvbj5cbjwvZGl2PlxuIiwiPHdvYS1pY29uLWJ1dHRvbj48L3dvYS1pY29uLWJ1dHRvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFNSztRQUFBO1FBQUE7TUFBQTtNQU5MO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQ0s7TUFBQTtNQUFBO0lBQUE7SUFBQTtrQkFETDtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUtLO2dCQUxMO0lBTWdDO01BQzVCO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFnRTtJQUM5RDs7OztJQVJEO0lBQ0E7SUFETCxTQUFLLFVBQ0EsU0FETDtJQUtLO0lBTEwsU0FLSyxTQUxMO0lBT3VDO0lBQW5DLFNBQW1DLFNBQW5DOzs7OztJQ1BKO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTs7O0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSw2QkFBQTs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/buttons/icon-button/icon-button.component.ngfactory.ts